import ongcLogo from "../../assets/images/ONGC_Logo.png";
import oilIndiaLogo from "../../assets/images/oilindialogo.png";
import getcoLogo from "../../assets/images/getcologo.png";
import cairnLogo from "../../assets/images/cairn_oil_and_gas_logo.png";
import selanLogo from "../../assets/images/Selan_Exploration_logo.jpg";
import jtiLogo from "../../assets/images/jti_japan_tobacco_international_logo.jpg";
import neuvoLogo from "../../assets/images/Neuvo_logo.webp";
import stoneHillLogo from "../../assets/images/StoneHill_logo.webp";
import radialDrillingLogo from "../../assets/images/Radial_Drilling_logo.webp";
import punjLloydLogo from "../../assets/images/Punj_Lloyd_logo.jpg";
import LazyImage from "../common/LazyImage/LazyImage";
import MotionReveal from "../common/MotionReveal/MotionReveal";

function ClientLogosMarquee() {
  const clients = [
    { name: "ONGC", logo: ongcLogo },
    { name: "Oil India", logo: oilIndiaLogo },
    { name: "GETCO", logo: getcoLogo },
    { name: "Cairn", logo: cairnLogo },
    { name: "Selan", logo: selanLogo },
    { name: "Punj Lloyd", logo: punjLloydLogo },
    { name: "JTI", logo: jtiLogo },
    { name: "Neuvo", logo: neuvoLogo },
    { name: "Stone Hill", logo: stoneHillLogo },
    { name: "Radial Drilling", logo: radialDrillingLogo },
  ];

  const marqueeClients = [...clients, ...clients];

  return (
    <section className="bg-slate-900 overflow-hidden py-16 lg:py-20">
      <MotionReveal variant="fadeUp" className="text-center mb-12 sm:mb-16">
        <span className="uppercase tracking-[0.3em] text-red-500 text-sm font-semibold">
          Trusted Partnerships
        </span>
        <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
          Trusted By Industry Leaders
        </h2>
      </MotionReveal>

      <div className="relative">

  <div className="flex gap-10 animate-[scroll_25s_linear_infinite] whitespace-nowrap">

    {marqueeClients.map((client, index) => (
      <div
        key={`${client.name}-${index}`}
        className="
        flex
        h-[120px]
        min-w-[220px]
        items-center
        justify-center
        rounded-[24px]
        bg-white
        p-3
        shadow-xl
        transition-all
        duration-300
        hover:-translate-y-1
        sm:p-4
        "
      >
        <LazyImage
          src={client.logo}
          alt={client.name}
          className="h-full w-full object-contain object-center"
        />
      </div>
    ))}

  </div>

</div>

    </section>
  );
}

export default ClientLogosMarquee;
